<div class="click-to-minimize-sec" (click)="toggleCalendar()">
  <div>
      <span class="c-icon c-icon--main"><i class="fa fa-chevron-down" [ngClass]="{'fa-chevron-up':showStatus,'fa-chevron-down':!showStatus}" aria-hidden="true"></i></span>
  </div>
</div>

